import decoder from "jwt-decode";
import { uuid } from "../utils/";

function authService(
	$logger,
	$userProfile
) {
	const svc = this;
	svc.logout = logout;
	svc.getCurrentUrl = getCurrentUrl;
	svc.uuid = uuid;
	svc.setAuthData = setAuthData;

	function setAuthData(oAuthUser) {
		const accessObject = decoder(oAuthUser.access_token);

		const userSubscriberId = oAuthUser.profile.sub;
		const subscriberClaims = userSubscriberId.split("_");
		const userDbId = subscriberClaims[2];

		const authData = {
			expires: accessObject.exp,
			issued: accessObject.nbf,
			user: {
				userId: oAuthUser.profile.sub,
				name: oAuthUser.profile.name,
				username: oAuthUser.profile.preferred_username,
				roles: [oAuthUser.profile.role],
				databaseId: userDbId
			}
		};

		$userProfile.setUser(authData.user || {});
		$logger.user(authData.user.userId);

		const currentProfile = $userProfile.getUserProfile();
		currentProfile.user = authData;
		$userProfile.setUserProfile(currentProfile);

		return authData;
	}


	function logout() { }

	function getCurrentUrl() {
		return (
			location.protocol +
			"//" +
			location.hostname +
			(location.port ? ":" + location.port : "")
		);
	}

	return svc;
}

export default angular
	.module("vesl.services.auth", [])
	.service("auth", authService).name;
